/*
 * @class rlFeaturedArticle
 * @memberOf jQuery.fn
 */

(function ($) {
    //////////////////////////////
    //set margin top/left on orientation of author page image & feature article page author profile image
    //(this function sets the image within the centre of the parent wrapper)
    //////////////////////////////
    function ProfileImageLayout() {
        const Authorimage = $('.featurearticlePage .AuthorProfile--headshot .rounded-circle img'),
                Authorcircle = $('.featurearticlePage .AuthorProfile--headshot .rounded-circle').width();
                Authorimage_width = Authorimage.width(),
                Authorimage_height = Authorimage.height();

        if (Authorimage_height > Authorimage_width) {
            let margintop = (Authorcircle - Authorimage_height) / 2;
            Authorimage.css('margin-top', margintop);
        }
        else if (Authorimage_width > Authorimage_height) {
            let marginleft = (Authorcircle - Authorimage_width) / 2;
            Authorimage.css('margin-left', marginleft);
        }
    }

    //Published Date and Read time row checker
    function AuthorMeta() {

        const Published = $('.feature-article-header-basic__meta__date'),
            ReadTime = $('.feature-article-header-basic__meta__time'),
            Divider = $('.feature-article-header-basic__meta__divider');

        if (Published.length > 0 && ReadTime.length > 0) {
            const PublishedPosition = Published.offset().top,
                ReadTimePosition = ReadTime.offset().top;

            if (ReadTimePosition > PublishedPosition) {
                Divider.addClass('hide');
            }
            else {
                Divider.removeClass('hide');
            }
        }
        
    }

    AuthorMeta();
    ProfileImageLayout();

    $(window).on('resize-end', function () {
        AuthorMeta();
        ProfileImageLayout();
    });


}(jQuery));

// Due to CSS constraints this fixes layout for mobile, by cloning the aside column and using show/hide depending on window width.
(function ($) {

  $('.ArticleIntro').each(function(){
  
    var $aside = $(this).find('.feature-article-aside');
    var $asideClone =  $(this).find('.feature-article-aside-clone');

    // inject clone and hide it.
    $asideClone.html($aside.html()).hide();

      $(window).on('resize', function () {
        if ($(window).width() > 767) {
          $asideClone.hide();
          $aside.show();
        } else {
          $asideClone.show();
          $aside.hide();
        }
      });

      $(window).trigger('resize');
    
  });
}(jQuery));
